module.exports = __webpack_public_path__ + "static/logo-a09462a3240c723aa034834961357cd1.svg";